module.exports = __webpack_public_path__ + "img/galvanic.a23fc7e2.png";